// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { testTemplateAttributeId } from './TestTemplateAttribute';
import { testTabularColumnLineageId } from './TestTabularColumnLineage';
import { z } from 'zod';
export const testTemplateTabularColumnId = (z.number());
export const testTemplateTabularColumn = z.object({
    id: testTemplateTabularColumnId,
    template_attribute_id: testTemplateAttributeId,
    name: z.string(),
    data_type: z.string(),
    is_index: z.boolean(),
    is_computed: z.boolean(),
    formula: z.string().nullable(),
    formula_result_unit: z.string().nullable(),
    formula_result_display_unit: z.string().nullable(),
    required: z.boolean(),
    unit: z.string().nullable(),
    sort_order: z.number(),
    display_width: z.number().nullable(),
    created_at: z.date(),
    updated_at: z.date(),
    code: z.string().nullable(),
    lineage_id: testTabularColumnLineageId,
    text_options: z.string().array().nullable(),
});
export const testTemplateTabularColumnInitializer = z.object({
    id: testTemplateTabularColumnId.optional(),
    template_attribute_id: testTemplateAttributeId,
    name: z.string(),
    data_type: z.string(),
    is_index: z.boolean().optional(),
    is_computed: z.boolean().optional(),
    formula: z.string().optional().nullable(),
    formula_result_unit: z.string().optional().nullable(),
    formula_result_display_unit: z.string().optional().nullable(),
    required: z.boolean().optional(),
    unit: z.string().optional().nullable(),
    sort_order: z.number().optional(),
    display_width: z.number().optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    code: z.string().optional().nullable(),
    lineage_id: testTabularColumnLineageId,
    text_options: z.string().array().optional().nullable(),
});
export const testTemplateTabularColumnMutator = z.object({
    id: testTemplateTabularColumnId.optional(),
    template_attribute_id: testTemplateAttributeId.optional(),
    name: z.string().optional(),
    data_type: z.string().optional(),
    is_index: z.boolean().optional(),
    is_computed: z.boolean().optional(),
    formula: z.string().optional().nullable(),
    formula_result_unit: z.string().optional().nullable(),
    formula_result_display_unit: z.string().optional().nullable(),
    required: z.boolean().optional(),
    unit: z.string().optional().nullable(),
    sort_order: z.number().optional(),
    display_width: z.number().optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    code: z.string().optional().nullable(),
    lineage_id: testTabularColumnLineageId.optional(),
    text_options: z.string().array().optional().nullable(),
});
//# sourceMappingURL=TestTemplateTabularColumn.js.map